import { Dispatch } from "redux";
import { IPack } from "../models";
import { DashboardActionTypes } from "../models/dashboardActions";
import { CREATE_PACK } from "../types";

export default (pack: IPack, callback: () => void) => (dispatch: Dispatch<DashboardActionTypes>) => {
    dispatch({
        type: CREATE_PACK,
        payload: pack,
    });
    callback();
};
